import React, { useState, useContext, useEffect } from 'react';

const ImpressaoTabela = () => {
    return (
        <>
        impressao
        </>
    )
}

export default ImpressaoTabela;